"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectedMainEntityInfo = /** @class */ (function () {
    function SelectedMainEntityInfo() {
        this.metaFields = [];
        this.lookupFields = [];
        this.textFields = [];
        this.filterFields = [];
        this.columnFields = [];
        this.documentFields = [];
        this.nameMetaFieldIds = [];
        this.instanceFieldSystemName = '';
    }
    return SelectedMainEntityInfo;
}());
exports.SelectedMainEntityInfo = SelectedMainEntityInfo;
//# sourceMappingURL=selected-main-entity-info.js.map